/*This file was generated by Fumadocs. Do not edit this file directly. Any changes should be made by running the generation command again.*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Check if a cache artifact exists",
  "description": "Check that a cache artifact with the given `hash` exists. This request returns response headers only and is equivalent to a `GET` request to this endpoint where the response contains no body.",
  "full": true,
  "_openapi": {
    "method": "HEAD",
    "route": "/v8/artifacts/{hash}",
    "toc": [],
    "structuredData": {
      "headings": [],
      "contents": [{
        "content": "Check that a cache artifact with the given `hash` exists. This request returns response headers only and is equivalent to a `GET` request to this endpoint where the response contains no body."
      }]
    }
  }
};
export let structuredData = {
  "contents": [{
    "content": "Check that a cache artifact with the given `hash` exists. This request returns response headers only and is equivalent to a `GET` request to this endpoint where the response contains no body."
  }],
  "headings": []
};
export const toc = [];
function _createMdxContent(props) {
  const {APIPage} = props.components || ({});
  if (!APIPage) _missingMdxReference("APIPage", true);
  return _jsxs(_Fragment, {
    children: ["\n", _jsx(APIPage, {
      document: "./.openapi.json",
      operations: [{
        "path": "/v8/artifacts/{hash}",
        "method": "head"
      }],
      webhooks: [],
      hasHead: false
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
